import ajax from '@utils/ajax';

const rootUrl = '/capsiminbox/authoring-platform/api/version';

const rootAdminUrl = '/capsiminbox/admin/api/versions';

export const getDemoLink = async (versionKey) =>
  await ajax('GET', `${rootAdminUrl}/demo-link/${versionKey}`);

export const getList = async () => await ajax('GET', `${rootAdminUrl}`, { list: true });

export const getVersionInfo = async (versionKey) =>
  await ajax('GET', `${rootAdminUrl}/${versionKey}`);

export const createVersion = async ({ payload }) =>
  await ajax('POST', `${rootAdminUrl}`, JSON.stringify(payload));

export const deleteVersion = async ({ versionKey }) =>
  await ajax('DELETE', `${rootAdminUrl}/${versionKey}`);

export const duplicateVersion = async ({ versionKey }) =>
  await ajax('GET', `${rootAdminUrl}/duplicate/${versionKey}`);

export const updateVersion = async ({ versionKey, payload }) =>
  await ajax('PUT', `${rootAdminUrl}/${versionKey}`, JSON.stringify(payload));

export const getParticipantResults = async ({ versionKey }) =>
  await ajax('GET', `${rootUrl}/${versionKey}/participant-results`);

export const getParticipantCounts = async ({ versionKey }) =>
  await ajax('GET', `${rootUrl}/${versionKey}/participant-count`);

export const getAllStudentData = async ({ versionKey, page, count, sortBy, direction }) =>
  await ajax(
    'GET',
    `${rootUrl}/${versionKey}/participant-results/all-scores?page=${page}&count=${count}&sortBy=${sortBy}&direction=${direction}`
  );

export const getSkillScoreOverview = async ({ versionKey }) =>
  await ajax('GET', `${rootUrl}/${versionKey}/skill-score-overview`);

export const getMostRecentProj = async (authorKey) =>
  await ajax('GET', `${rootAdminUrl}/author/${authorKey}`);

export const getFeaturedProjects = async () =>
  await ajax('GET', `${rootAdminUrl}/feature-projects`);


  export const getActorVersions = async (authorKey) =>
  await ajax('GET', `${rootUrl}/actor-versions`);